module.exports = __webpack_public_path__ + "d1d6c38a7c92c89cb4342cdf71562bef.pdf";